// CREATED BY ATHARVA SHAH & ISHANI MATHUR FOR EXTC DEPARTMENT

const testimonialsJson = [
  {
    name: "Ms. TANYA ANUPAM",
    yearOfGraduation: "2024",
    higherEducation: "WorkIndia",
    description: "Over the next 40-50 years of my life, I recognize these four college years as fundamentally transformative. Engaging deeply in a variety of activities, I believe, is essential during this period. College is about exploration, discovering passions, and pursuing them vigorously. I am proud to say that I have seized a wide array of opportunities, excelling in each one and never losing sight of my broader goals. From rigorous academics to diverse co-curricular and extracurricular activities, coupled with active social engagement, I have embraced the full spectrum of college life. Moreover, I have consistently kept my professional ambitions in sharp focus, exploring both tech and non-tech fields through internships at some of the most prestigious firms. The 4 years of SPIT have been incredible with many academic and life lessons that have broadened my horizon.",
    imageUrl: "https://i.ibb.co/gJ5Grhk/tanya-anupam.png",
  },
  {
    name: "Mr. HARISH BALASUBRAMANIAN",
    yearOfGraduation: "2024",
    higherEducation: "Johns Hopkins University, Baltimore, Maryland, United States",
    description: "SPIT has taught me a lot over the 4 years. I learnt how to be a more confident human being and in the process of learning, I also learnt how to fit into the professional world. Apart from education, SPIT has given me abundant resources, through advice from faculty and mentorship, and research opportunities to further my career. I am also thankful to SPIT for all the opportunities that I got, such as getting accepted to my dream program at Johns Hopkins University for Biomedical Engineering. I will also be grateful to the professors and teachers, for making my 4 years memorable.",
    imageUrl: "https://i.ibb.co/F5KpYV4/harish-bala.jpg",
  },
  {
    name: "Ms. RIYA GOENKA",
    yearOfGraduation: "2024",
    higherEducation: "JPMorgan Chase & Co.",
    description: "My college journey has been transformative. From the initial excitement of exploring new subjects to the challenges that pushed me to grow, each experience has shaped my understanding of myself and the world around me. Through hard work, dedication, and the support of peers and mentors, I've not only gained knowledge but also developed invaluable skills in critical thinking, time management, and collaboration. It's been a journey of self-discovery, academic achievement, and personal growth, preparing me for the next chapter of my life with confidence and enthusiasm.",
    imageUrl: "https://i.ibb.co/TH0hmR2/riya-goenka.jpg",
  },
  {
    name: "Ms. GAUTAM SHRUTI KRISHNAVATAR",
    yearOfGraduation: "2024",
    higherEducation: "InCred Financial Services",
    description: "My journey at SPIT has been nothing short of remarkable, filled with growth, challenges, and triumphs that have shaped me in profound ways. Becoming the chairperson of a technical committee in my very first year was both daunting and exhilarating. It set the stage for what would become an incredible journey of personal and professional development. Reaching the finals of Ideabank ignited my passion for problem-solving and led to winning first prize in the DhanaYukta Financial Analysis competition. Additionally, I explored competitions like Flipkart Robotics and e-Yantra, advancing to the quarter-finals in the latter.  But SPIT wasn't just about academic accolades; it was a place where I discovered hidden talents and passions. Organizing a fashion show, especially after the hiatus imposed by the pandemic, was a deeply fulfilling experience that allowed me to explore my creative side and connect with my peers in a meaningful way.Beyond the events and competitions, SPIT was a community of like-minded individuals who became my mentors, collaborators, supportive seniors and some of the best friends. Their unwavering support and encouragement pushed me beyond my comfort zone and helped me realize my full potential.",
    imageUrl: "https://i.ibb.co/CzwvdfM/shruti-gautam.png",
  },
  {
    name: "Mr. KAUSTUBH GHARE",
    yearOfGraduation: "2024",
    higherEducation: "Oracle - Oracle Financial Services Software",
    description: "My time at SPIT has been absolutely wonderful. From the very beginning, I was drawn into a world of exciting studies and a variety of extracurricular activities. The people I met along the way were not just smart, but also incredibly welcoming and fun, which made my college life really enjoyable. I got to participate in entrepreneurship competitions, cultural festivals, and sports events, all of which added to the excitement of my college days. Everyone at SPIT, from the lab assistants to the librarians and professors, was super supportive and encouraging right from the start. This support made a huge difference in my personal and professional growth. The foundation that SPIT has given me is something I deeply value. It's been a memorable and cherished part of my life, and I'm so thankful for it. As I move on from being a student to an alumnus, I'm looking forward to staying involved and helping SPIT grow even more. My journey here was truly a blessing, filled with joy and great learning experiences that I will always hold dear.",
    imageUrl: "https://i.ibb.co/nbpfvLj/kaustubh-ghare.jpg",
  },
{
    name: "Mr. HEET JAIN",
    yearOfGraduation: "2024",
    higherEducation: "MBA, IIM Calcutta",
    description: "S.P.I.T will always be very close to my heart as it has played such an important role in enabling me to learn and experience so many things across different avenues through the various opportunities it offered. I will always have immense respect for this institution which I will proudly call my alma mater and the years that I have spent here will always be very special for me!",
    imageUrl: "https://i.ibb.co/XtKwN1f/heet-jain.png",
  },
{
    name: "Mr. AARNAV JOSHI",
    yearOfGraduation: "2024",
    higherEducation: "M.S., Carnegie Mellon University",
    description: "My time at SPIT has been truly remarkable, filled with diverse experiences spanning from academics and to cultural activities. Over these four years, I've had the privilege of meeting like-minded individuals who maintained a competitive yet conducive atmosphere to ensure one strives for success at every point. Throughout this journey, I've learnt the importance of both hard work and smart work, serving as important tools for meeting deadlines. The memories forged here will forever hold a special place in my heart, serving as invaluable lessons that have paved the way for my future endeavors. I extend my deepest appreciation to the esteemed faculty and support staff who have consistently guided and supported students in every step of the way. Being part of SPIT has truly been a blessing, expanding my horizons and equipping me with the necessary skills to succeed in my career ahead.",
    imageUrl: "https://i.ibb.co/tMK8xct/aarnav-joshi.jpg",
  },
{
    name: "Mr. Aditya Kulkarni",
    yearOfGraduation: "2024",
    higherEducation: "M.S. ETH Zurich, Switzerland",
    description: "In my academic journey, I owe a debt of gratitude to SPIT, for providing me with a nurturing environment where I could flourish both academically and personally. With a steadfast commitment to excellence, I've strived to make the most of the opportunities presented to me. Maintaining a strong CGPA was just the beginning. Through the support and encouragement of my professors, principal SPIT and peers, I delved into research and innovation, embarking on enriching internships at institutions like IIT Bombay and BARC. These experiences not only expanded my knowledge but also honed my practical skills, preparing me for the challenges that lay ahead. Beyond academics, SPIT offered me a platform to explore my passions and interests through various extracurricular activities. From winning competitions to spearheading social impact initiatives like the WiSE project at IIT Bombay, every endeavor has been a testament to the holistic education I received at SPIT. Securing a grant for our 'Drones for Smart Agriculture' project stands as a shining example of the support and encouragement I've received from the college community. As I reflect on my journey, I'm deeply grateful to SPIT for shaping me into the individual I am today and for instilling in me the values of perseverance, excellence, and social responsibility.",
    imageUrl: "https://i.ibb.co/4Z8SMQM/aditya-kulkarni.png",
  },
{
    name: "Mr. GURUPRASAD PARASNIS",
    yearOfGraduation: "2024",
    higherEducation: "M.S., University of California San Diego",
    description: "My journey at SPIT has been a rollercoaster ride of challenges, triumphs, failures and fightbacks, but most importantly it has been one of constant learning and bettering myself every day. I have met people who are competitive in every aspect this world has to offer and sharing my academic journey with them has been a privilege. In these four years, these people have pushed me to bring the best out of myself and try to excel in all walks of life that are possible. They have taught me to not be monotonous. The diverse culture at SPIT has ingrained determination, positivity and leadership skills to face the outer world. The external opportunities offered through SPIT have upgraded my technical skills to be competent in any part of the industry. These four years at SPIT were perhaps the most important and life-changing years of my career and I would cherish them for years to come.",
    imageUrl: "https://i.ibb.co/P4LgcTg/guruprasad-p.png",
  },
{
    name: "Ms. VRUSHALI  VARUDE",
    yearOfGraduation: "2024",
    higherEducation: "M.S., University of Southern California",
    description: "As a new entrant to college during the Covid years, I didn't have many expectations for college life. However, becoming a member of SPIT turned out to be a fulfilling journey that met all my hopes. From participating in Oculus to managing my grades while maintaining continuous assessment, to embarking on a six-month research internship, I witnessed firsthand our esteemed institution's commitment to fostering a vibrant research culture. Winning recognition for our team's funded project as the best hardware project of the year was a highlight. Most importantly, I cultivated meaningful relationships not only with peers but also with faculty and staff. This multidimensional journey has shaped me into the person I am proud to be today, equipped with the skills and experiences necessary for success in my future endeavors.",
    imageUrl: "https://i.ibb.co/LnVkgj0/vrushali-varude.png",
  },
{
    name: "Mr. Atharav Bhagwat",
    yearOfGraduation: "2024",
    higherEducation: "Masters in Engineering Management (MEM) Dartmouth College",
    description: "My journey of four years at SPIT has been an unforgettable chapter that will forever resonate within me. It's surreal to comprehend that four years have flown by since I embarked on this educational odyssey, and now, as I bid farewell, I'm filled with a mix of nostalgia and gratitude. Reflecting on my growth, both professionally and personally, from the moment I stepped into the institution to where I stand today, I recognize the profound impact SPIT has had on shaping my character and fostering a sense of professionalism within me. Collaborating with brilliant minds and esteemed faculty members on various projects has not only enriched my engineering knowledge but has also nurtured leadership and teamwork skills vital for my future endeavors. I extend my heartfelt gratitude to my classmates, batchmates, and all the dedicated faculty and staff whose unwavering support has made my four years of engineering truly remarkable and enriching. Being a part of the SPIT community has been an absolute privilege, and I am immensely grateful for the blessings it has bestowed upon me.",
    imageUrl: "https://i.ibb.co/sKbybdX/atharav-bhagwat.png",
  },
{
    name: "Mr. Arpit Patil",
    yearOfGraduation: "2024",
    higherEducation: "Stevens Institute of Technology",
    description: "Having completed my B. Tech in Electronics Engineering from SPIT College, I look back at my journey with a sense of accomplishment and gratitude. The past four years have been a time of immense growth and learning, both academically and personally. SPIT College provided me with a solid foundation in electronics engineering, equipped me with practical skills, and instilled in me a passion for innovation. As I step out into the world, I am excited to apply everything I have learned and to make meaningful contributions to the field of electronics engineering.",
    imageUrl: "https://i.ibb.co/hKkMF2W/arpit-patil.png",
  },
{
    name: "Mr. VINEET MANKANI",
    yearOfGraduation: "2024",
    higherEducation: "MSCI",
    description: "My journey at S.P.I.T. has been full of splendid experiences, whether it be learning about academics or making connections. Over the course of these four years, I have made some great friends who have helped me explore the world beyond academics. I have participated in and led many competitions, thereby contributing to my personal and intellectual growth. I have had the privilege of representing several esteemed student bodies throughout the college, such as the Training and Placement Office, serving as the Technical Head at the Students' Council, Industry Relations Cell, IEEE, along with being one of the founding members of the IEEE AESS Student Chapter at S.P.I.T. This journey has undeniably fostered my active participation and enhanced my openness to opportunities in life ahead. Looking back on the time spent at S.P.I.T., I am filled with gratitude for the experiences it has offered me, and I feel a sense of pride.",
    imageUrl: "https://i.ibb.co/826dHyv/vineet-mankani.png",
  },
{
    name: "Mr. NARAYAN GAWAS",
    yearOfGraduation: "2024",
    higherEducation: "Deutsche Bank",
    description: "Having completed my B. Tech in Electronics Engineering from SPIT College, I look back at my journey with a sense of accomplishment and gratitude. The past four years have been a time of immense growth and learning, both academically and personally. SPIT College provided me with a solid foundation in electronics engineering, equipped me with practical skills, and instilled in me a passion for innovation. As I step out into the world, I am excited to apply everything I have learned and to make meaningful contributions to the field of electronics engineering.",
    imageUrl: "https://i.ibb.co/vHv3cxP/narayan-gawas.png",
  },
{
    name: "Mr. SHASHANK JAGTAP",
    yearOfGraduation: "2024",
    higherEducation: "Baker Hughes",
    description: "Admitted as a direct second-year student, my time at S.P.I.T was transformative. Over three swift years, I immersed myself in a vibrant academic atmosphere, gaining valuable technical and professional skills. Engaging in projects, collaborating with peers, and participating in extracurricular activities enriched my learning experience and sharpened my problem-solving abilities. Securing a placement offer from Baker Hughes was a testament to the knowledge and skills I acquired at S.P.I.T.  Grateful for the support of faculty , seniors and friends, I cherish the memories and lessons that have prepared me for my career journey ahead",
    imageUrl: "https://i.ibb.co/F4nvtfQ/shashank-jagtap.png",
  },
{
    name: "Ms. RUTIKA SHINDE",
    yearOfGraduation: "2024",
    higherEducation: "Transunion",
    description: "My time at SPIT has been truly transformative. From navigating challenging exams to participating in cultural events and competitions, each experience has contributed to my growth. Through dedication and collaboration with peers, I've overcome obstacles and achieved success. The support of faculty and staff has been invaluable, guiding me through tough times and empowering me to thrive. These memories will forever inspire me, shaping my path toward future endeavors. Grateful for the enriching journey at SPIT, I look forward to the promising opportunities ahead.",
    imageUrl: "https://i.ibb.co/w0NZG7B/rutika-shinde.png",
  },
{
    name: "Ms. SRUSHTI GAIKWAD",
    yearOfGraduation: "2024",
    higherEducation: "RBL Bank",
    description: "My journey at SPIT has been an incredible rollercoaster ride, filled with countless highs and lows. From the adrenaline-fueled rush of late-night study sessions to the euphoria of unforgettable college fests, each experience has left an indelible mark on my life. I've delved into various facets of campus life, from actively participating in NGOs to embarking on thrilling treks. Every step has been a lesson, teaching me resilience, compassion, and the value of community. Engaging in different committees honed my leadership skills and taught me the intricacies of event organization. It's been eye-opening to witness firsthand the dedication and effort required to pull off successful initiatives. Academically, the journey hasn't been without its challenges, but the unwavering support of teachers and the camaraderie among peers have seen me through even the toughest of times. Overall, my time at SPIT has been a transformative journey of self-discovery, growth, and countless memories that I'll cherish for a lifetime.",
    imageUrl: "https://i.ibb.co/7VGMxz4/srushti-gaikwad.png",
  },
{
    name: "Mr. YUG HARLALKA",
    yearOfGraduation: "2024",
    higherEducation: "Oracle",
    description: "My time at SPIT has been incredibly fulfilling, encompassing a diverse array of experiences spanning academics and cultural engagements. Over these four years, I've encountered like-minded peers, fostering mutual growth. We participated in numerous college events, while learning the value of diligence and collaboration. These memories are invaluable, shaping my future endeavors. I extend heartfelt thanks to the esteemed faculty and supportive staff for their unwavering guidance. SPIT has been a blessing, enriching my perspectives and paving the way for promising opportunities ahead.",
    imageUrl: "https://i.ibb.co/Rc4v5xc/yug-harlika.png",
  },
  {
    name: "Mr. SAHIL KRISHNADAS",
    yearOfGraduation: "2020",
    higherEducation: "Carnegie Mellon University, US",
    description: "My time at SPIT was a transformative experience, blending practical curriculum, passionate faculty, and diverse research opportunities. The vibrant student life added a unique perspective and strong community bond. This holistic approach prepared me for advanced studies at Carnegie Mellon University, equipping me with the skills to navigate the global landscape. Proud to be part of this community, SPIT continues to shape my journey.",
    imageUrl: "https://i.ibb.co/rtdjTT0/1.jpg",
  },
  {
    name: "Mr. SAURABH JENA",
    yearOfGraduation: "2017",
    higherEducation: "Reliance Jio Infocomm Ltd, Mumbai",
    description: "My 4-year experience at the EXTC department of S.P.I.T was phenomenal and fulfilling. I learned extensively, not just academically but also holistically. Credit goes to professors like you and my peers, who were humble, approachable, and motivated us to see the bigger picture. Being regarded highly as a S.P.I.T alumnus speaks volumes about the institute's brand and legacy. I am proud to be part of the alumni community.",
    imageUrl: "https://i.ibb.co/VLqRQRZ/img6.jpg",
  },
  {
    name: "Ms. VETEKAR MICHELLE",
    yearOfGraduation: "2018",
    higherEducation: "JP Morgan, Mumbai | New York",
    description: "My four years at SPIT were the most impactful in my journey. SPIT taught me technical knowledge and nurtured my entrepreneurial interests, instilling a lifelong attitude of perseverance. Joining the EXTC department, I worked with ISRO in my second year, gaining insights into the Indian Space Industry. Starting a company in my third year, supported by flexible professors, I grew it to serve over 20 global clients and was offered incubation with SP-TBI. Now, as an Investment Banking Analyst at JP Morgan in New York, I credit SPIT for preparing me to handle global clients confidently.",
    imageUrl: "https://i.ibb.co/5Tp9SS2/img8.jpg",
  },
  {
    name: "Mr. AKHIL SARDESAI",
    yearOfGraduation: "2018",
    higherEducation: "IIM Indore | PepsiCo",
    description: "My 4 years at SPIT's ExTC Department were full of learning, self-discovery, industry exposure, and fun. The environment catered to all students, with technically inclined students benefiting from labs, IEEE workshops, and robotics, while others like me could explore semi-technical subjects or join business clubs. With SPIT now autonomous, the syllabus has modernized, offering more practical learning and longer internships. I highly recommend joining SPIT's ExTC branch for a wonderful 4-year journey filled with learning and opportunity.",
    imageUrl: "https://i.ibb.co/m0dMpkJ/img13.jpg",
  },
  {
    name: "Mr. KRISHNA BHATU",
    yearOfGraduation: "2018",
    higherEducation: "University of Maryland | PlusOne Robotics, Texas, USA ",
    description: "Studying EXTC in my bachelor's degree exposed me to diverse career paths like robotics, computer vision, cybersecurity, satellite engineering, and radio engineering. This experience helped me discover my career interests and prepared me for the diverse industry landscape. My advice to new students is to not only focus on coursework but also to learn a programming language, as coding skills are essential for any application engineer",
    imageUrl: "https://i.ibb.co/GvtsLxN/img18.jpg",
  },
  {
    name: "Mr. KRISHNADITYA KANCHARLA",
    yearOfGraduation: "2019",
    higherEducation: "Amazon Web Services, Bangalore",
    description: "As a student of SPIT, I found the academic atmosphere conducive to learning which facilitated in identifying my area of interest. Apart from the robust curriculum, numerous hands-on workshops on cutting-edge technologies were conducted which I found to be incredibly valuable. I am grateful to the faculty for being extremely supportive and providing me with a plethora of opportunities to enhance and showcase my skills.",
    imageUrl: "https://i.ibb.co/w6fzzFQ/img22.jpg",
  },
  {
    name: "Ms. SALONI SHAH",
    yearOfGraduation: "2019",
    higherEducation: " IIT Bombay",
    description: "Being a student at SPIT was one of the best experiences of my life, offering both technical education and essential life skills for the corporate world. The EXTC Department provided practical knowledge through labs and competitions, enhancing my understanding of theoretical concepts. The placement cell deserves special appreciation for their efforts in preparing students for placements. To aspiring SPITians, it will be a rewarding experience where you will learn, grow, and build a successful career, while creating cherished memories.",
    imageUrl: "https://i.ibb.co/SsJ9xNq/img25.jpg",
  },
  {
    name: "Mr. SHUBHAM SIDHWA",
    yearOfGraduation: "",
    higherEducation: "Georgia Institute of Technology (Computer Vision and Machine Learning) | View, Inc., Tennessee, United States",
    description: "As a student in the Bachelors program in EXTC at SPIT, I gained the skills and confidence to use my knowledge in practical applications. Taking courses like Digital Image Processing, Signal Processing, Neural Networks were great assets and are some of the basic concepts I use in my work everyday. The EXTC department helped me gain knowledge of not only working on the software but also the hardware of any project which is an added advantage. I would highly recommend the EXTC department at SPIT to anyone wanting to expand his horizon and gain experience and knowledge both at the same time to get a perfect head start in his/hers career trajectory.",
    imageUrl: "https://i.ibb.co/FDmdZBQ/img30.jpg",
  },
  {
    name: " Ms. MANSI SHARMA",
    yearOfGraduation: "2018",
    higherEducation: "Associate Consultant, Capgemini, Mumbai",
    description: "My journey with Sardar Patel Institute of Technology is definitely one I will cherish for life. In a very short span of time, I was able to learn a lot, which helped me excel academically, as well as personally. S.P.I.T. aims at overall development of an individual and also provides multiple opportunities and exposure to develop new skills. Students are able to showcase their talent not just through technical but also through extra-curricular activities. My experience with the faculty in Electronics and Telecommunication branch has been good. The competitive environment always pushed me to perform my best. All this experience and learning helped me bag a job at Capgemini. I'm grateful that I could be a part of this institute.",
    imageUrl: "https://i.ibb.co/CW72b9q/img38.jpg",
  },
  {
    name: "Mr. NIKET SHAH",
    yearOfGraduation: "2018",
    higherEducation: "M.S. (Robotics), University of Maryland, College Park | Robotics Software Engineer, Airgility, Maryland, USA",
    description: "The four years at SPIT has been a brilliant experience, with exposure in both theory and practical domain. EXTC as a branch was a great choice for me as it opened a lot of doors for me after my graduation having the basic conceptual knowledge of a lot of domains. The department has been really helpful with many knowledgable professors and the course is also designed in a brilliant way with a blend of courses and lab experiments. A message to the future students would be to join EXTC if you want to explore different domains and figure out your forte.",
    imageUrl: "https://i.ibb.co/9GCJDH7/img39.jpg",
  },
  {
    name: "Mr. EESHAAN ASODEKAR",
    yearOfGraduation: "2023",
    higherEducation: "M.S., New York University, U.S",
    description:
      "My academic and overall experience in SPIT was crucial in helping me to select my career path in quant finance. The professors have been very helpful, across the semesters, and they are very open and want to help you and see you succeed. Also, the element of academic competition, and the general competitive nature of the students helped me to incrementally improve myself.",
    imageUrl: "https://i.ibb.co/T005vBR/image002.jpg",
  },
  {
    name: "Mr. DHANANJAY JOSHI",
    yearOfGraduation: "2023",
    higherEducation: "M.S., University of Minnesota Twin Cities",
    description:
      "As an electronics undergraduate student at SPIT, my journey has been nothing short of incredible. These four years were a whirlwind of new experiences and learning: meeting new friends, solving problems with different perspectives, developing skills, connecting with a community of professionals, and a lot more. I would like to thank all the faculties that guided me to pursue a graduate degree in the domain of my interest, VLSI design. Moreover, I would like to thank my seniors and fellow students who have helped me build the foundation for my life ahead.",
    imageUrl: "https://i.ibb.co/PrX872n/image004.jpg",
  },
  {
    name: "Mr. TIRTH PATEL",
    yearOfGraduation: "2023",
    higherEducation: "M.S., University of Michigan, Ann Arbor, U.S",
    description:
      "Coming to SPIT has been a very enriching journey, giving me the right opportunities to flourish both academically and outside the classroom. During my time here, I met extremely talented and hardworking people and had the fortune of forming lifelong friendships with a lot of them. SPIT also gave me a platform to pursue my research interests at premier institutions like the Indian Institute of Technology, Bombay. I am also eternally grateful to the faculty for their timely and apt guidance and to my classmates for our good times. I am certain that the things I have learned here will stay with me for life and help me grow in my career and as a person.",
    imageUrl: "https://i.ibb.co/9GGttV6/image006.jpg",
  },
  {
    name: "Mr. TIRTH MEGHANI",
    yearOfGraduation: "2023",
    higherEducation: "M.S. Delft University of Technology, Netherlands",
    description:
      "My journey with SPIT College has been nothing short of amazing. From the moment I stepped foot on campus, I was greeted with a vibrant and energetic atmosphere that set the tone for an incredible college experience. One of the most notable aspects of SPIT College is its emphasis on providing a well-rounded education. The academic opportunities offered at SPIT are diverse and comprehensive, ensuring that I received a holistic learning experience.",
    imageUrl: "https://i.ibb.co/sVbVFF2/image008.jpg",
  },
  {
    name: "Mr. CHINMAY WALINJKAR",
    yearOfGraduation: "2023",
    higherEducation: "M.S., North Carolina State University, U.S",
    description:
      "My introduction to electronics and computers goes back to the excitement of choosing my first phone in the 8th grade. It was through playing around with it, installing a newer operating system, flashing more battery-efficient kernels and mods, even to the extent of bricking it (I couldn't boot into the OS), that I realized – my future lies in the tech industry.",
    imageUrl: "https://i.ibb.co/mrpQBgG/image010.jpg",
  },
  {
    name: "Mr. SANSKAR BADJATIA",
    yearOfGraduation: "2023",
    higherEducation: "M.S. , University of Southern California, U.S",
    description:
      "My journey at SPIT has been a transformative one with diverse experiences and growth opportunities. From engaging lectures that challenged my perspectives to late night study sessions that forged lasting friendships, every moment has contributed to shaping my intellectual and personal development. I also engaged in multiple extracurricular activities and participated in student clubs and events which expanded my horizons and nurtured my leadership skills.",
    imageUrl: "https://i.ibb.co/fH7fMw2/image012.jpg",
  },
  {
    name: "Mr. SHIVANG SINGH MANHAS",
    yearOfGraduation: "2023",
    higherEducation: "Rutgers University, U.S",
    description:
      "Over the course of my four-year journey in S.P.I.T., I experienced a transformative period of personal growth and academic development. In my first year, I embarked on a new chapter, adjusting to the S.P.I.T. environment, forming new friendships, and exploring various academic disciplines.",
    imageUrl: "https://i.ibb.co/hXdxc1W/image014.jpg",
  },
  {
    name: "Mr. GANESH ARPAN NOOKALA",
    yearOfGraduation: "2023",
    higherEducation:
      "M.S., Rutgers University, State University of New Jersey, U.S",
    description:
      "My undergraduate journey at Sardar Patel Institute of Technology was remarkable. Through the institute's robust alumni network, I secured an invaluable internship opportunity at Google Devices, an experience that broadened my horizons and connected me with industry leaders.",
    imageUrl: "https://i.ibb.co/4ZBsbhd/image016.jpg",
  },
  {
    name: "Ms. DIVIJA SHRINGARPURE",
    yearOfGraduation: "2023",
    higherEducation: "M.S., North Carolina State University, U.S",
    description:
      "My journey at S.P.I.T was transformative and wholesome, nurturing my academic, professional, and personal growth. Inspiring faculty, helpful lab assistants, and motivating peers shaped my skills and guided my specialization choice. Extracurricular activities strengthened my personality. It was a challenging, yet grateful and unforgettable experience.",
    imageUrl: "https://i.ibb.co/NSjTwqC/image018.jpg",
  },
  {
    name: "Mr. ADITYA UMALKAR",
    yearOfGraduation: "2023",
    higherEducation: " M.S., North Carolina State University, U.S",
    description:
      "My years at SPIT have been marvelous. Starting at the beginning and finally reaching towards the end has been a rollercoaster ride. Many things, both good and bad stuck along during the process, but overall the college has played a great role in shaping me as a person and an academic.",
    imageUrl: "https://i.ibb.co/wcgYGr3/image020.jpg",
  },
  {
    name: "Mr. PULKIT CHAUDHARI",
    yearOfGraduation: "2023",
    higherEducation: "Deutsche Bank",
    description:
      "First and foremost, I would like to extend my heartfelt thanks to the faculty members who imparted their knowledge and expertise during my academic journey. Their commitment to providing a comprehensive and engaging curriculum has undoubtedly prepared me for the challenges that lie ahead.",
    imageUrl: "https://i.ibb.co/qxmqhbR/image022.jpg",
  },
  {
    name: "Ms. SRUTHI SHIVARAMAKRISHNAN",
    yearOfGraduation: "2023",
    higherEducation: "Auxo AI",
    description:
      "S.P.I.T provided a wonderful chance for me to grow, learn and explore my interests. It gave me an opportunity to network with like minded people. I got to participate in various national level competitions, as well as take up many extra courses as a part of my curriculum.",
    imageUrl: "https://i.ibb.co/31f3Rds/image024.jpg",
  },

  {
    name: "Ms. SAYALI AYRE",
    yearOfGraduation: "2023",
    higherEducation: "J.P. Morgan Chase & Co.",
    description:
      "Throughout my coursework, I immersed myself in subjects such as communication systems, control systems, and signal processing. These areas broadened my understanding of the applications of electronics in various industries, from telecommunications to robotics and automation.",
    imageUrl: "https://i.ibb.co/XjVDT1V/image026.jpg",
  },
  {
    name: "Ms. AROHI SHINDE",
    yearOfGraduation: "2023",
    higherEducation: "J.P. Morgan Chase & Co.",
    description:
      "My journey at Sardar Patel Institute of Technology was wonderful! I got to experience everything, be it the technical, non-technical, cultural or social activities, it provided a well-balanced blend of academics and co-curricular activities.",
    imageUrl: "https://i.ibb.co/52tn5FK/image028.jpg",
  },
  {
    name: "Mr. OMKAR SHINDE",
    yearOfGraduation: "2023",
    higherEducation: "J.P. Morgan Chase & Co.",
    description:
      "My journey at SPIT has been an amazing one, with varied experiences ranging from academics to cultural events. In these four years, I met like-minded people that helped each other grow symbiotically.",
    imageUrl: "https://i.ibb.co/R2pm2c5/image030.jpg",
  },
  {
    name: "Ms. DABHANE JANHAVI",
    yearOfGraduation: "2023",
    higherEducation: "J.P. Morgan Chase & Co.",
    description:
      "I started as direct second year student, it started online but did not feel like online faculty and friends were supportive enough to help in academics and in activities as well.",
    imageUrl: "https://i.ibb.co/RvCGnmf/image032.jpg",
  },
  {
    name: "Ms. VAISHNAVI BHORE",
    yearOfGraduation: "2023",
    higherEducation: "Siemens",
    description:
      "My journey in SPIT was very great in these 4 years of journey I learned a lot. Also, it taught me how to apply my knowledge practically. ",
    imageUrl: "https://i.ibb.co/64NQ3GW/image033.jpg",
  },
  {
    name: "Mr. JENIL DAVE",
    yearOfGraduation: "2023",
    higherEducation: "Institutional Shareholder Services Inc. (ISS)",
    description:
      "This would be the most significant and important chapter and phase of my life. SPIT assisted me in transforming myself. Through an incredible transformation, I was able to expand my boundaries and limits.",
    imageUrl: "https://i.ibb.co/8cZzpCf/image036.jpg",
  },
  {
    name: "Mr. PARTH LENDE",
    yearOfGraduation: "2023",
    higherEducation: "Oracle",
    description:
      "My journey at SPIT and especially ETRX branch has been a great one, I got to learn many new things from my professors and mates.",
    imageUrl: "https://i.ibb.co/4WT2LmT/image038.jpg",
  },
  {
    name: "Mr. RAHUL PARAB",
    yearOfGraduation: "2023",
    higherEducation: "BDO India LLP",
    description:
      "The institute went above and beyond to support and nurture my engineering aspirations, igniting a sense of curiosity within me and inspiring me to tackle real-world challenges.",
    imageUrl: "https://i.ibb.co/tb4hKc6/image040.jpg",
  },
  {
    name: "Mr. VINAYAK TRIPATHI",
    yearOfGraduation: "2023",
    higherEducation: "Institutional Shareholder Services Inc. (ISS)",
    description:
      "I look back on my four-year journey at SPIT with immense gratitude. The college has provided me with an environment that fostered my growth as an engineer and as an individual.",
    imageUrl: "https://i.ibb.co/tHnQ2QX/image042.jpg",
  },
  {
    name: "Mr. SHAHID SHAIKH",
    yearOfGraduation: "2023",
    higherEducation: "Quantiphi",
    description:
      "My four-year B.Tech journey at Sardar Patel Institute of Technology (SPIT), Mumbai, was an extraordinary and transformative experience.",
    imageUrl: "https://i.ibb.co/m5y3WsN/image044.gif",
  },
  {
    name: "Ms. TEJAL DADAS",
    yearOfGraduation: "2023",
    higherEducation: "Axis Bank",
    description:
      "My experience at SPIT has been wonderful. However, a little amount, as I changed my Department and its COVID zone. I am a direct second-year student. ",
    imageUrl: "https://i.ibb.co/jZ6g36g/image046.jpg",
  },
  {
    name: "Mr. DEVANSH PALLIYATH",
    yearOfGraduation: "2023",
    higherEducation: "Quantiphi Analytics Solution Private Limited",
    description:
      "I am proud to say that I studied for my BTech in S.P.I.T one of the best colleges in Mumbai. It was a very exciting and a very wonderful experience overall.",
    imageUrl: "https://i.ibb.co/tqJc4v7/image048.jpg",
  },
  {
    name: "Mr. SANDEEP SUTHAR",
    yearOfGraduation: "2023",
    higherEducation: "IDfy",
    description:
      "My journey with S.P.I.T. (Sardar Patel Institute of Technology) College has been an incredible adventure of personal and intellectual growth. ",
    imageUrl: "https://i.ibb.co/WDdfbDG/image050.jpg",
  },
  {
    name: "Mr. VIVEK THAKKAR",
    yearOfGraduation: "2023",
    higherEducation: "Ugam Solutions (Merkle).",
    description:
      "My journey at SPIT was great. Even with staying at home for 2 years due to pandemic, I had the opportunity of organising an event and participating in many competitions too.",
    imageUrl: "https://i.ibb.co/NCpqPQM/image052.jpg",
  },
  {
    name: "Mr. SHUBHAM SAWANT",
    yearOfGraduation: "2023",
    higherEducation: "Oracle",
    description:
      "My experience at SPIT has been nothing short of incredible, encompassing a wide array of academic and cultural endeavors.",
    imageUrl: "https://i.ibb.co/GsVh9Rn/image054.jpg",
  },
  {
    name: "Mr. MAYUR KUMAR",
    yearOfGraduation: "2023",
    higherEducation: "JP Morgan Chase and Co.",
    description:
      "My journey at SPIT has been an amazing one. I can remember myself in the first year and after all these years I see where I have reached.",
    imageUrl: "https://i.ibb.co/KKcsnTg/image056.jpg",
  },
  {
    name: "Ms. CHETANA KAMALKAR",
    yearOfGraduation: "2023",
    higherEducation: "J.P. Morgan Chase & Co.",
    description:
      "My four-year graduate college journey at Sardar Patel Institute of Technology (SPIT) is an enriching and transformative experience that prepares students for successful careers in their chosen fields.",
    imageUrl: "https://i.ibb.co/bFst2Rv/image058.jpg",
  },
  {
    name: "Mr. VINAY POLEWAR",
    yearOfGraduation: "2023",
    higherEducation: "J.P. Morgan Chase & Co.",
    description:
      "My journey at Sardar Patel Institue Technology was a roller coaster ride. With many ups and down because of covid .",
    imageUrl: "https://i.ibb.co/47WX3L8/image060.jpg",
  },
  {
    name: "Ms. NIDHI KHANORKAR",
    yearOfGraduation: "2023",
    higherEducation: "Quantiphi",
    description:
      "My journey at SPIT has been a fulfilling and enriching one. The diverse crowd and experienced faculty allowed to me grow immensely in these 4 years.",
    imageUrl: "https://i.ibb.co/hHgnJCr/image062.jpg",
  },
  {
    name: "Ms. RENUKA DYAWARKONDA",
    yearOfGraduation: "2023",
    higherEducation: "Nomura",
    description:
      "It has been a great journey, had a great opportunity to explore and learn new things. Had a great experience in academics as well. Compared to other colleges had a better level of education firm.",
    imageUrl: "https://i.ibb.co/xsTnJsd/image064.jpg",
  },
  {
    name: "Mr. DHVANIK MAKWANA",
    yearOfGraduation: "2023",
    higherEducation: "Baker Hughes",
    description:
      "Throughout my time at SPIT (Sardar Patel Institute of Technology), I embarked on an incredible journey filled with diverse experiences, ranging from academic pursuits to cultural events.",
    imageUrl: "https://i.ibb.co/Gv7QXCh/image066.jpg",
  },
  {
    name: "Mr. PRATHAMESH KADAM",
    yearOfGraduation: "2023",
    higherEducation: "Baker Hughes",
    description:
      "My experience at SPIT, my engineering college, has been truly remarkable. From academic endeavors to active participation in cultural events, I have witnessed personal and professional growth firsthand.",
    imageUrl: "https://i.ibb.co/0BscxKM/image068.jpg",
  },
  {
    name: "Mr. PUJAN SONI",
    yearOfGraduation: "2023",
    higherEducation: "JP Morgan Chase & Co.",
    description:
      "My graduate program in SPIT has been a total rollercoaster ride, starting with the first year filled with lots of enthusiasm and sports and getting used to college courses.",
    imageUrl: "https://i.ibb.co/8sZzMg8/image070.jpg",
  },
  {
    name: "Ms. RANI TIBDEWAL",
    yearOfGraduation: "2023",
    higherEducation: "JP Morgan Chase & Co.",
    description:
      "S.P.I.T. has been a remarkable journey for me. Throughout my academic journey, I embraced numerous opportunities to assume leadership roles within different committees.",
    imageUrl: "https://i.ibb.co/QPsTwSz/image072.jpg",
  },
  {
    name: "Mr. HITANSHU JAIN",
    yearOfGraduation: "2023",
    higherEducation: "Transunion",
    description:
      "My journey at S.P.I.T has been an incredible one. The campus, with its picturesque lake and close connection to nature, created a peaceful and inspiring atmosphere for learning.",
    imageUrl: "https://i.ibb.co/p2dn9RV/image074.gif",
  },
  {
    name: "Mr. OJAS PAL",
    yearOfGraduation: "2023",
    higherEducation: "Nomura",
    description:
      "After completing my Bachelor of Technology (B.Tech) degree in Electronics Engineering from Sardar Patel Institute of Technology (SPIT), I can confidently say that my college experience has been truly transformative and rewarding.",
    imageUrl: "https://i.ibb.co/hDY9CrT/image076.jpg",
  },
  {
    name: "Ms. ADITI BAGWE",
    yearOfGraduation: "2023",
    higherEducation: "JP Morgan Chase & Co.",
    description:
      "My journey at SPIT was a transformative period in my life that encompassed academic, personal, and social growth. ",
    imageUrl: "https://i.ibb.co/Wg6H4Pr/image078.jpg",
  },
  {
    name: "Mr. IMAZ CHANDIWALA",
    yearOfGraduation: "2023",
    higherEducation: "Deloitte India",
    description:
      "I had an amazing journey at SPIT. I am thankful for everything this college has given me, a lot of friends, great placement, and a lot of learning.",
    imageUrl: "https://i.ibb.co/jJqXL0M/image080.jpg",
  },
  {
    name: "Mr. SIDDHARTH DESHPANDE",
    yearOfGraduation: "2023",
    higherEducation: "GEP",
    description:
      "During my time at SPIT, I have had an incredible journey filled with a diverse range of experiences encompassing academics and cultural events.",
    imageUrl: "https://i.ibb.co/MBc2Z0s/image082.jpg",
  },
  // {
  //   name: "Ms. BHAVIKA VAISHNAVI",
  //   yearOfGraduation: "2023",
  //   higherEducation: "JP Morgan Chase & Co.",
  //   description:
  //     "As an alumnus of this esteemed institution, I cannot emphasize enough how my experience at Sardar Patel Institute of Technology has shaped my academic and personal growth.",
  //   imageUrl: "https://i.ibb.co/hCSqMqd/image084.jpg",
  // },
  // {
  //   name: "Ms. SHRADDHA BHAGYAWANT",
  //   yearOfGraduation: "2023",
  //   higherEducation: "BDO LLP",
  //   description:
  //     "As a student at Sardar Patel Institute of Technology (SPIT), my four-year journey in engineering would be filled with growth, challenges, and memorable experiences.",
  //   imageUrl: "https://i.ibb.co/SJV0Rx1/image086.gif",
  // },
  // {
  //   name: "Mr. SARVESH JARE",
  //   yearOfGraduation: "2023",
  //   higherEducation: "BNP PARIBAS ISPL",
  //   description:
  //     "My journey with SPIT has been great, I have so many experiences during these 4, and I have learned so many different things in curricular and extracurricular also.",
  //   imageUrl: "https://i.ibb.co/4W4MtHB/image088.gif",
  // },
  // {
  //   name: "Ms. ANUSHKA PILENA",
  //   yearOfGraduation: "2023",
  //   higherEducation: "Colgate Global Business Services Private Limited",
  //   description:
  //     "My journey at SPIT has been like a roller coaster with ups and downs, twists, and turns, exciting and thrilling.",
  //   imageUrl: "https://i.ibb.co/0qkrXZQ/image090.jpg",
  // },
  // {
  //   name: "Mr. PARAM MEHTA",
  //   yearOfGraduation: "2023",
  //   higherEducation: "OMP - INDIA",
  //   description:
  //     "I am deeply grateful for my transformative journey as an electronics engineer at S.P.I.T. The college's dynamic community, dedicated faculty, and emphasis on practical learning shaped my professional development.",
  //   imageUrl: "https://i.ibb.co/pLd2Vdw/image092.jpg",
  // },
  // {
  //   name: "Mr. SURAJ KAMTEKAR",
  //   yearOfGraduation: "2023",
  //   higherEducation: "Colgate Global Business Services",
  //   description:
  //     "My journey at SPIT has been great, as I joined in the second year, after completing my 3 years diploma.",
  //   imageUrl: "https://i.ibb.co/yQMC5FH/image094.jpg",
  // },
  // {
  //   name: "Mr. SUMIT KULKARNI",
  //   yearOfGraduation: "2023",
  //   higherEducation: "BNP Paribas",
  //   description:
  //     "During my time at Sardar Patel Institute of Technology, I had an enriching and rewarding journey. The institute played a crucial role in shaping my engineering education.",
  //   imageUrl: "https://i.ibb.co/mtGnkWZ/image096.jpg",
  // },
  // {
  //   name: "Mr. BILAL SANI",
  //   yearOfGraduation: "2023",
  //   higherEducation: "Ugam (Merkel)",
  //   description:
  //     "During my time at SPIT, I embarked on an incredible journey filled with a diverse range of experiences in academics and cultural events.",
  //   imageUrl: "https://i.ibb.co/Ph94GCg/image098.jpg",
  // },
  // {
  //   name: "Ms. POOJA KHISMATRAO",
  //   yearOfGraduation: "2023",
  //   higherEducation: "LTIMindtree",
  //   description:
  //     "My journey at SPIT has been grateful. One of the best things about college life is that I got a new experience every day.",
  //   imageUrl: "https://i.ibb.co/bz58ytV/image100.jpg",
  // },
  // {
  //   name: "Mr. SWARAJ SALUNKE",
  //   yearOfGraduation: "2023",
  //   higherEducation: "BDO India LLP",
  //   description:
  //     "It was an amazing journey at SPIT. The best part about college is a college campus, oculus, free space in college, and friends.",
  //   imageUrl: "https://i.ibb.co/RNj9kBF/image102.jpg",
  // },
  // {
  //   name: "Mr. LOKESH PATIL",
  //   yearOfGraduation: "2023",
  //   higherEducation: "MAQ Software",
  //   description:
  //     "I had a great experience at SPIT. The curriculum is great. I had met lots of students who came from a very competitive environment.",
  //   imageUrl: "https://i.ibb.co/k62rw8Q/image103.jpg",
  // },
  // {
  //   name: "Mr. RAHUL ALSHI",
  //   yearOfGraduation: "2023",
  //   higherEducation: "Colgate Global Business Services Private Limited",
  //   description:
  //     "My journey at SPIT has been very enthralling and enjoying. All the staff and teachers have been very supportive, and I would thank them for their guidance.",
  //   imageUrl: "https://i.ibb.co/3NS7tZR/image106.jpg",
  // },
];

export default testimonialsJson;
